module.exports = __webpack_public_path__ + "static/img/3-select-return-order-goods.90b3a7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-select-return-order-goods.png
// module id = 1338
// module chunks = 0